import { ChBaseModule } from './../ch-base/ch-base.module';
import { ChEmailComponent } from './ch-email.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '../../../../shared/translate/translate.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [ChEmailComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    ChBaseModule,
    TranslateModule,
  ],
  exports: [
    ChEmailComponent
  ]
})
export class ChEmailModule { }
